import TileLayer from "ol/layer/Tile";
import XYZ from "ol/source/XYZ";
import { HereAerialMapsURL, HereLabelsURL, HereMapsURL, HereSatelliteMapsURL } from '@/config/externalUrl.js';
const defaultTileLayers = () => ({
    satelliteTileLayer: new TileLayer({
        source: new XYZ({
            url: HereSatelliteMapsURL,
            maxZoom: 20,
        }),
        crossOrigin: "anonymous",
        visible: false,
    }),

    propertyTileLayer: new TileLayer({
        source: new XYZ({
            url: "/tile/tileserver.php?/index.json?/property_ccc/{z}/{x}/{y}.png",
        }),
        visible: false,
    }),

    osmTileLayer: new TileLayer({
        source: new XYZ({
            url: HereMapsURL,
            maxZoom: 20,
        }),
        visible: true,
        crossOrigin: "anonymous",
    }),
    aerialTileLayer: new TileLayer({
        source: new XYZ({
            url: HereAerialMapsURL,
            maxZoom: 20,
        }),
        visible: false,
        maxZoom: 20,
        crossOrigin: "anonymous",
    }),
    aerialServerTileLayer: new TileLayer({
        source: new XYZ({
            urls: ["/tile/tileserver.php?/index.json?/ccc/{z}/{x}/{y}.jpg"],
            minZoom: 12,
            maxZoom: 19,
            tilePixelRatio: 1,
        }),
        visible: false,
    }),
    labelsTileLayer: new TileLayer({
        source: new XYZ({
            url: HereLabelsURL,
        }),
        visible: false,
        maxZoom: 20,
        crossOrigin: "anonymous",
    }),
});


export default defaultTileLayers;